import { t } from "i18next";

const generateNewAdvertising = ({
  type,
  languageId,
}: {
  type: string;
  languageId: string;
}) => ({
  type,
  label: t("newCampaign", {
    ns: "editor-advertisings",
  }),
  ...(type === "csai_mp4" && {
    translations: [
      {
        default: true,
        language_uuid: languageId,
        url: "",
      },
    ],
    translations_indexes: {
      language_uuid: languageId,
      default: { true: [0] },
    },
  }),
});

export default generateNewAdvertising;
